module.exports = __webpack_public_path__ + "img/诺德整形.0731e03.png";